import React from 'react';

const ToothIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M9.33 3.458c-1.33.541-2.43 1.43-3.21 2.55-.78 1.12-1.12 2.459-1.12 3.992 0 2.21 1.79 4 4 4s4-1.79 4-4c0-1.533-.34-2.872-1.12-3.992-.78-1.12-1.88-2.009-3.21-2.55a2 2 0 0 0-1.34 0z" />
    <path d="m14.67 3.458c1.33.541 2.43 1.43 3.21 2.55.78 1.12 1.12 2.459 1.12 3.992 0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.533.34-2.872 1.12-3.992.78-1.12 1.88-2.009 3.21-2.55a2 2 0 0 1 1.34 0z" />
    <path d="M12 14v8" />
    <path d="M15.5 22a2.5 2.5 0 1 1-6 0" />
  </svg>
);

export default ToothIcon;
